// extracted by mini-css-extract-plugin
export default {"list":"approved-quotation-resume-modal_list__r-FVw"};